<template>
  <div>
    <div class="lke-titl">
      <i class="el-icon-caret-right"></i>
      当前位置：查看信息
    </div>
    <div class="lke-text">
      <span>查看信息</span>
    </div>
    <el-form
      label-position="left"
      :model="ruleForm"
      ref="ruleForm"
      label-width="90px"
      class="demo-ruleForm"
    >
      <el-form-item label="用户名">
        <span v-if="roles === 'notEnrolled'">{{ userInfo.sid }}</span>
        <span v-else>{{ userInfo.sid }}</span>
      </el-form-item>
      <el-form-item label="姓名">
         <span>{{ userInfo.name }}</span>
      </el-form-item>
      <el-form-item label="出生日期">
         <span>{{ userInfo.borndate | time }}</span>
      </el-form-item>
      <el-form-item label="性别">
         <span>{{ userInfo.sex | sex }}</span>
      </el-form-item>
      <el-form-item label="手机">
         <span>{{ userInfo.mobile }}</span>
      </el-form-item>
      <!-- <el-form-item>
        <el-button type="primary" @click="submit" :loading="loading" size="mini"
          >修改</el-button
        >
        <el-button type="info" size="mini" @click="opback">返回</el-button>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import moment from "moment"
import { changeuserinfo } from "@/api/index";
export default {
  props: {},
  data() {
    return {
      loading: false,
      ruleForm: {
        name: "",
        borndate: "",
        sex: 0,
        mobile: "",
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    roles() {
      return this.$store.state.roles;
    },
  },
  created() {
    this.ruleForm = {
      name: this.userInfo.name,
      borndate: this.userInfo.borndate,
      sex: this.userInfo.sex,
      mobile: this.userInfo.mobile,
    };
  },
  mounted() {},
  watch: {},
  filters: {
    sex(val) {
      if (val === 1) {
        return '男'  
      }else if(val === 2){
        return '女'
      } else {
        return ''
      }
    },
    time(val) {
      if (val) {
        return moment(val).format("YYYY-MM-DD");
      } else {
        return ''
      }
    }
  },
  methods: {
    opback() {
      this.$router.go(-1);
    },

    submit() {
      this.loading = true;
      if (this.ruleForm.name === "") {
        this.$message({
          message: "请输入姓名",
          type: "warning",
        });
        this.loading = false;
        return;
      }
      if (this.ruleForm.borndate === "") {
        this.$message({
          message: "请选择出生日期",
          type: "warning",
        });
        this.loading = false;
        return;
      }
      if (this.ruleForm.sex === 0) {
        this.$message({
          message: "请选择性别",
          type: "warning",
        });
        this.loading = false;
        return;
      }
      if (this.checkPhone(this.ruleForm.mobile)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
        this.loading = false;
        return;
      }
      let obj = {
        student: this.ruleForm,
      };
      changeuserinfo(obj).then((response) => {
        this.$message({
          message: "修改成功",
          type: "success",
        });
        this.$store.commit("userInfo", response);
        this.ruleForm = {
          name: this.userInfo.name,
          borndate: this.userInfo.borndate,
          sex: this.userInfo.sex,
          mobile: this.userInfo.mobile,
        };
      });
      this.loading = false;
    },

    checkPhone(val) {
      let phone = val;
      if (!/^1[3456789]d{9}$/.test(phone)) {
        return false;
      } else {
        return true;
      }
    },
  },
  components: {},
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style scoped>
::v-deep.el-form-item {
  margin-bottom: 0px;
}
::v-deep.el-input {
  width: 250px;
}
.lke-titl {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-bottom: 20px;
}
.lke-titl > i {
  color: #2890f4;
  padding-right: 5px;
  font-size: 20px;
}
.lke-text {
  border: 1px solid #dddddd;
  padding: 15px 0 15px 35px;
  font-weight: bold;
  background: #f9f9f9;
  margin-bottom: 20px;
}
.lke-text > span {
  font-size: 16px;
  color: #2890f4;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/xgxx/xgxx.vue